
import { Options, mixins } from "vue-class-component";
import PosService from "../../service/PosService.js";
import ProfilerService from "../../service/ProfilerService.js";
import ChartService from "../../service/ChartService.js";
import Toaster from "../../helpers/Toaster";
import AutoComplete from "primevue/autocomplete";
import SearchFilter from "../../components/SearchFilter.vue";
import PosPreviewReceipt from "../../components/PosPreviewReceipt.vue";
import PaymentScreen from "../../components/PaymentScreen.vue";
import { useStore, ActionTypes } from "../../store";
import UtilityOptions from "../../mixins/UtilityOptions";

interface PaymentListType {
    paymentType: string;
    accountNo: string;
    terminalId: string;
    authCode: string;
    transId: string;
    transStatus: string;
    transType: string;
    transDate: string;
    transTime: string;
    transAmount: number;
    transTotalAmount: number;
    transRef: string;
    entryMode: string;
    hostResponse: string;
    giftCardRef: string;
    cardBalance: string;
    tendered: number;
    change: number;
    roundOff: number;
    bankID: number;
}

@Options({
    title: "Transactions",
    components: {
        PaymentScreen,
        AutoComplete,
        SearchFilter,
        PosPreviewReceipt,
    },
})
export default class TransactionReceipt extends mixins(UtilityOptions) {
    private lists = [];

    private selectedReceiptData = {
        paymentTransactions: [] as any[],
    };
    private supplierFilter = true;
    private profilerList = [];
    private accountHeadList = [];
    private totalAmountStatement = "Total Amount Received";
    private statement = "";
    private menuBar = false;
    private paymentDialog = false;
    private dialogTitle = "";
    private toast;
    private goToFirstLink = 0;
    private receiptNO = "";
    private previewHeading = "";
    private receiptID = 0;
    private receiptService;
    private profilerService;
    private chartService;
    private previewTransactionDialog = false;
    private previewPosReceipt = false;
    private productDialog = false;
    private filterDialog = false;
    private submitted = false;
    private statusDialog = false;
    private checkPagination = true;
    private totalRecords = 0;
    private totalBalanceReceipt = 0;
    private limit = 0;
    private home = { icon: "pi pi-home", to: "/" };
    private items = [{ label: "Transactions", to: "/process/transactions" }];
    private scanBuffer = "";
    private totalAmountAllRecords = 0;
    private totalBalanceAllRecords = 0;
    private latency = 0;
    private cashPaymentOption = true;
    private cardPaymentOption = true;
    private bankTransferPaymentOption = true;
    private payLaterOption = true;
    private chequePaymentOption = false;
    private scenario = "";
    private supplierCreditAmount = 0;
    private paySupplierCredit = false;
    private branchCreditAmount = 0;
    private payBranchCredit = false;
    private pendingPaymentMethods: any[] = [];
    private tsoAllowedMethods: string[] = [];
    private tsoPreloadedPayments: any[] = [];
    private tsoConfirmDialog = false;
    private tsoReceivingBranch = "";

    private selectedDateFilter = { key: "This Month", value: "this_month" };
    private counterEntry = [
        {
            accountID: 0,
            accountHead: "",
            amount: 0,
            type: "Debit",
        },
    ];

    get receiptTypes() {

        const types = [
            { key: "Pay Later Receipts", value: "PayLater" },
            { key: "Sales Receipt", value: "INE" },
            { key: "Refund Receipt", value: "RFD" },
            // { key: "Transfer Stocks", value: "TRN" },
            // { key: "Arrived Stocks", value: "ASR" },
            { key: "Purchase Receipt", value: "PUR" },
            { key: "Purchase Return", value: "RPU" },
            { key: "Stock Adjustment Additions", value: "SAA" },
            { key: "Stock Adjustment Deductions", value: "SAD" },
        ];

        if (this.canStockTransfer) {
            types.push({ key: "Stock Transfers Out", value: "TSO" });
            types.push({ key: "Stock Transfers In",  value: "TSI" });
        }

        return types;

    }
    

    private itemFilter = {
        keyword: "",
        filterType: "this_month",
        storeID: 0,
        date1: "",
        date2: "",
        type: "INE",
        customerName: "All",
        UserName: "All",
        customerID: 0,
        userID: 0,
        supplierID: 0,
        branchID: 0,
    };

    private paymentList: PaymentListType[] = [];

    private item = {
        id: 0,
        profileID: 0,
        selectedProfile: "",
        type: "",
        status: "",
    };

    //CALLING WHEN PAGINATION BUTTON CLICKS
    onPage(event) {
        this.loadList(event.first);
    }

    //DEFAULT METHOD OF TYPE SCRIPT
    created() {
        this.receiptService = new PosService();
        this.profilerService = new ProfilerService();
        this.chartService = new ChartService();
        this.toast = new Toaster();
    }

    //CALLNING AFTER CONSTRUCTOR GET CALLED
    mounted() {
        if (this.$route.query.additionalFilter) {
            this.itemFilter.type = "" + this.$route.query.additionalFilter;
            this.selectedDateFilter = { key: "All", value: "all" };
            this.itemFilter.filterType = "all";
            this.scenario = "PayLater";
        }
        if (this.$route.query.supplier_id) {
            this.itemFilter.supplierID = Number(this.$route.query.supplier_id);
            this.items.unshift({
                label: "Supplier Credits",
                to: "/home/suppliers",
            });
        }
        if (this.$route.query.branch_id) {
            this.itemFilter.branchID = Number(this.$route.query.branch_id);
            this.selectedDateFilter = { key: "All", value: "all" };
            this.itemFilter.filterType = "all";
            this.items.unshift({
                label: "Branch Credits",
                to: "/home/branch-credits",
            });
        }
        if (this.$route.query.type) {
            this.itemFilter.type = "" + this.$route.query.type;
        }
        this.loadList(0);
        // Add event listener for keypress
        window.addEventListener("keypress", this.handleKeypress);
    }

    beforeUnmount() {
        // Remove event listener
        window.removeEventListener("keypress", this.handleKeypress);
    }

    handleKeypress(event) {
        // Check for "Enter" key to detect the end of scanning
        if (event.key === "Enter") {
            this.loadSearchData();
        } else {
            // Accumulate characters in the buffer
            this.scanBuffer += event.key;
        }
    }

    //FETCH THE DATA FROM SERVER
    loadList(page) {
        this.receiptService
            .transactionList(this.itemFilter, page)
            .then((data) => {
                this.lists = data.records;
                this.totalRecords = data.totalRecords;
                this.limit = data.limit;
                this.statement = data.statement;
                this.calculateTotalAmount();
                this.calculateTotalBalance();
            });
    }

    loadSearchData() {
        this.submitted = true;
        if (this.itemFilter.keyword) {
            this.goToFirstLink = 0;
            this.loadList(this.goToFirstLink);
        }
    }

    updateFilterStatus(obj) {
        this.scenario = "";
        if (obj != null && obj.loading == "Yes") {
            this.itemFilter.filterType = obj.filterName.value;
            this.itemFilter.storeID = obj.storeID.id;
            this.itemFilter.date1 = obj.date1;
            this.itemFilter.date2 = obj.date2;
            this.itemFilter.keyword = "";
            this.itemFilter.customerName = obj.customerName;
            this.itemFilter.UserName = obj.userName;
            this.itemFilter.customerID = obj.customerID;
            this.itemFilter.userID = obj.userID;
            this.itemFilter.supplierID = obj.supplierID;

            this.goToFirstLink = 0;
            this.loadList(this.goToFirstLink);
        }
        this.filterDialog = false;
    }

    cleanSearchData() {
        this.submitted = true;
        this.itemFilter.keyword = "";
        this.goToFirstLink = 0;
        this.loadList(0);
    }

    openFilterDialog() {
        this.dialogTitle = "Filter Receipt";
        this.filterDialog = true;
    }

    openTransactionDialog() {
        this.previewTransactionDialog = true;
        this.menuBar = false;
    }

    openPaymentScreen() {
        this.menuBar = false;
        this.dialogTitle = "Receive Or Pay Receipt Dues";

        if (Number(this.totalBalanceReceipt) <= 0) {
            this.toast.showError("Receipt balance is not valid to proceed next");
            return;
        }

        if (this.item.type === 'TSO' && this.tsoPreloadedPayments.length > 0) {
            this.tsoConfirmDialog = true;
            return;
        }

        this.paymentDialog = false;
        this.paymentDialog = true;
        this.store.dispatch(
            ActionTypes.TOTAL_BILL,
            Number(this.formatAmount(this.totalBalanceReceipt))
        );
    }

    openMenu(data) {
        this.chequePaymentOption = data.type == "PUR" ? true : false;
        this.menuBar = true;
        this.selectedReceiptData.paymentTransactions = this.camelizeKeys(
            data.receipt_balance
        );

        if (
            (data.type === "SAA" || data.type === "SAD") &&
            data.pay_later &&
            data.pay_later.length > 0
        ) {
            const payLaterDues = this.camelizeKeys(data.pay_later).map(
                (p: any) => ({
                    createdAt: p.createdAt,
                    sourceType: data.type,
                    receiptNo: p.receiptNo,
                    paymentType: "Supplier Credit (Due)",
                    transTotalAmount: p.transAmount,
                    accountNo: "",
                    description: p.description,
                })
            );
            this.selectedReceiptData.paymentTransactions = [
                ...this.selectedReceiptData.paymentTransactions,
                ...payLaterDues,
            ];
        }
        this.item.type = data.type;
        this.item.profileID = data.profile_id;
        this.item.id = data.id;
        this.item.status = data.status;
        this.item.selectedProfile = data.profile_name.profileName;
        this.totalBalanceReceipt = this.calculateBalance(
            data.total_bill,
            data.receipt_balance
        );

        if (data.supplier && data.supplier.supplier_payable > 0) {
            this.supplierCreditAmount = data.supplier.supplier_payable;
            this.paySupplierCredit = true;
        } else {
            this.supplierCreditAmount = 0;
            this.paySupplierCredit = false;
        }
        if (data.type === 'TSI') {
            this.totalBalanceReceipt = Number(data.branch_credit_payable ?? 0);
            // Set branch credit claim option
            const availableReceivable = Number(data.branch_credit_receivable ?? 0);
            if (availableReceivable > 0) {
                this.branchCreditAmount = availableReceivable;
                this.payBranchCredit = true;
            } else {
                this.branchCreditAmount = 0;
                this.payBranchCredit = false;
            }
        } else if (data.type === 'TSO') {
            this.totalBalanceReceipt = Number(data.branch_credit_incoming ?? 0);
            this.branchCreditAmount = 0;
            this.payBranchCredit = false;
        } else {
            this.totalBalanceReceipt = this.calculateBalance(
                data.total_bill,
                data.receipt_balance
            );
            this.branchCreditAmount = 0;
            this.payBranchCredit = false;
        }

        if (data.type === 'TSO' && data.branch_credit_incoming > 0) {
            this.tsoPreloadedPayments = (data.pending_payment_methods ?? []).map((m: any) => ({
                paymentType: m.paymentType,
                paymentTypeID: m.paymentTypeID,
                amount: m.amount,
            }));
            this.tsoReceivingBranch = data.tso_counterpart_branch ?? '';
        } else {
            this.tsoPreloadedPayments = [];
            this.tsoReceivingBranch = '';
        }

        this.cashPaymentOption   = true;
        this.cardPaymentOption   = true;
        this.chequePaymentOption = data.type == "PUR" ? true : false;
        this.payLaterOption      = true;
        this.tsoAllowedMethods   = [];

        this.calculateDaysPassed(data.receipt_date);
    }

    closePaymentScreen() {
        this.paymentDialog = false;
        this.latency = 0;
    }

    previewDialog() {
        this.receiptID = this.item.id;
        this.previewPosReceipt = true;
        this.menuBar = false;
    }

    getProceededPayments(paymentList) {
        let list = paymentList;

        // TSI/TSO: a "BranchCredit" line is the unpaid remainder, not a payment.
        // Drop it so the ledger only settles what was actually claimed/paid.
        if (this.item.type === 'TSI' || this.item.type === 'TSO') {
            list = list.filter((p: any) => p.paymentTypeID != 9);
        }

        this.paymentList = list.map((p: any) => ({
            ...p,
            description: this.item.type === 'TSI'
                ? `Paid ${p.paymentType} for stock transfer`
                : p.description ?? '',
        }));

        this.setAccountingEntries();

        this.receiptService
            .savePayment(this.item, this.paymentList, this.counterEntry)
            .then((res) => {
                if (res.alert == "info") {
                    if (this.item.type == "INE") {
                        this.printReceipt();
                    }
                    this.loadList(this.goToFirstLink);
                    this.clearAll();
                }
                this.toast.handleResponse(res);
            });

        this.paymentDialog = false;
        this.submitted = false;
    }

    getPaymentMwthod(paymnetList) {
        let method = "";

        if (paymnetList.length == 0) {
            method = "Pay Later";
        } else if (paymnetList.length == 1) {
            method = paymnetList[0].paymentType;
        } else if (paymnetList.length > 1) {
            method = "Split";
        }

        return method;
    }

    clearAll() {
        this.paymentList = [];

        this.item = {
            id: 0,
            profileID: 0,
            selectedProfile: "",
            type: "",
            status: "",
        };
    }

    updatePreviewStatus() {
        this.receiptID = 0;
        this.previewPosReceipt = false;
    }

    printReceipt() {
        this.receiptService
            .getTreceiptdata(this.item.id, 2) // 2 means Remaining Payment
            .then((res) => {
                this.generatePosReceipt(res);
            });
    }

    generatePosReceipt(res) {
        if (res.original.htmlTemplate) {
            // Open a new window and write the HTML content to it
            const printWindow = window.open("", "_blank");
            if (printWindow !== null) {
                printWindow.document.open();
                printWindow.document.write(`
                        <html>
                            <head>
                                <title>Print Receipt</title>
                            </head>
                            <body onload="setTimeout(function() { window.print(); window.close(); }, 300)">
                                ${res.original.htmlTemplate} <!-- HTML content from the response -->
                            </body>
                        </html>
                    `);
                printWindow.document.close(); // Close the document
            }
        }
    }


    get currency() {
        return this.store.getters.getCurrency;
    }

    calculateDaysPassed(dateString) {
        // Convert string to Date object
        const givenDate = new Date(dateString);
        const today = new Date();

        // Ensure the values are treated as numbers using `.getTime()`
        const differenceInTime = today.getTime() - givenDate.getTime();

        // Convert milliseconds to days
        const differenceInDays = Math.floor(
            differenceInTime / (1000 * 60 * 60 * 24)
        );

        this.latency = differenceInDays;
    }

    get totalPaidCash() {
        let total = 0;

        this.paymentList.forEach((e) => {
            if (e.paymentType == "Cash") {
                total = total + e.transTotalAmount;
            }
        });

        return total;
    }

    get totalPaidBank() {
        let total = 0;
        this.paymentList.forEach((e) => {
            if (e.paymentType != "Cash"
                && (e as any).paymentTypeID != 5
                && (e as any).paymentTypeID != 7
                && (e as any).paymentTypeID != 9
                && (e as any).paymentTypeID != 10
            ) {
                total = total + e.transTotalAmount;
            }
        });
        return total;
    }

    get totalPaidSupplierCredit() {
        let total = 0;
        this.paymentList.forEach((e: any) => {
            if (e.paymentTypeID == 5) total += e.transTotalAmount;
        });
        return total;
    }

    get totalPaidSupplierCreditClaim() {
        let total = 0;
        this.paymentList.forEach((e: any) => {
            if (e.paymentTypeID == 7) total += e.transTotalAmount;
        });
        return total;
    }

    get totalPaidBranchCredit() {
        let total = 0;
        this.paymentList.forEach((e: any) => {
            if (e.paymentTypeID == 9) total += e.transTotalAmount;
        });
        return total;
    }

    get totalPaidBranchCreditClaim() {
        let total = 0;
        this.paymentList.forEach((e: any) => {
            if (e.paymentTypeID == 10) total += e.transTotalAmount;
        });
        return total;
    }

    setAccountingEntries() {
        this.counterEntry = [];

        const cashBankTotal = this.totalPaidCash + this.totalPaidBank;
        const scTotal       = this.totalPaidSupplierCredit + this.totalPaidSupplierCreditClaim;
        const bcTotal       = this.totalPaidBranchCredit + this.totalPaidBranchCreditClaim;
        const totalPaid     = cashBankTotal + scTotal;
        const totalPaidAll  = totalPaid + bcTotal; 

        if (totalPaidAll > 0) {
            if (this.item.type == "TSI") {
                if (this.totalPaidCash > 0) {
                    this.counterEntry.push({
                        accountID: 2, accountHead: "Cash in hand",
                        amount: this.totalPaidCash, type: "Credit",
                    });
                }
                if (this.totalPaidBank > 0) {
                    this.counterEntry.push({
                        accountID: 8, accountHead: "Cash at bank",
                        amount: this.totalPaidBank, type: "Credit",
                    });
                }
                if (this.totalPaidBranchCreditClaim > 0) {
                    this.counterEntry.push({
                        accountID: 73, accountHead: "Inter-Branch Receivable",
                        amount: this.totalPaidBranchCreditClaim, type: "Credit",
                    });
                }
                const tsiTotal = this.totalPaidCash + this.totalPaidBank + this.totalPaidBranchCreditClaim;
                this.counterEntry.push({
                    accountID: 74, accountHead: "Inter-Branch Payable",
                    amount: tsiTotal, type: "Debit",
                });

            } else if (this.item.type == "TSO") {
                if (this.totalPaidCash > 0) {
                    this.counterEntry.push({
                        accountID: 2, accountHead: "Cash in hand",
                        amount: this.totalPaidCash, type: "Debit",
                    });
                }
                if (this.totalPaidBank > 0) {
                    this.counterEntry.push({
                        accountID: 8, accountHead: "Cash at bank",
                        amount: this.totalPaidBank, type: "Debit",
                    });
                }
                if (this.totalPaidBranchCreditClaim > 0) {
                    this.counterEntry.push({
                        accountID: 74, accountHead: "Inter-Branch Payable",
                        amount: this.totalPaidBranchCreditClaim, type: "Debit",
                    });
                }
                const tsoIbrCredit = this.totalPaidCash + this.totalPaidBank + this.totalPaidBranchCreditClaim;
                if (tsoIbrCredit > 0) {
                    this.counterEntry.push({
                        accountID: 73, accountHead: "Inter-Branch Receivable",
                        amount: tsoIbrCredit, type: "Credit",
                    });
                }
            } else if (this.item.type == "INE" || this.item.type == "RPU" || this.item.type == "SAD") {
                if (this.totalPaidCash > 0) {
                    this.counterEntry.push({
                        accountID: 2, accountHead: "Cash in hand",
                        amount: this.totalPaidCash, type: "Debit",
                    });
                }
                if (this.totalPaidBank > 0) {
                    this.counterEntry.push({
                        accountID: 8, accountHead: "Cash at bank",
                        amount: this.totalPaidBank, type: "Debit",
                    });
                }
                if (this.totalPaidSupplierCredit > 0) {
                    this.counterEntry.push({
                        accountID: 5, accountHead: "Accounts payable",
                        amount: this.totalPaidSupplierCredit, type: "Debit",
                    });
                }
                if (this.totalPaidSupplierCreditClaim > 0) {
                    this.counterEntry.push({
                        accountID: 5, accountHead: "Accounts payable",
                        amount: this.totalPaidSupplierCreditClaim, type: "Debit",
                    });
                }
                this.counterEntry.push({
                    accountID: 4, accountHead: "Accounts receivable",
                    amount: totalPaid, type: "Credit",
                });

            } else if (this.item.type == "RFD" || this.item.type == "PUR" || this.item.type == "SAA") {
         
                const totalAPDebit = cashBankTotal + scTotal;
                if (totalAPDebit > 0) {
                    this.counterEntry.push({
                        accountID: 5, accountHead: "Accounts payable",
                        amount: totalAPDebit, type: "Debit",
                    });
                }
                if (this.totalPaidCash > 0) {
                    this.counterEntry.push({
                        accountID: 2, accountHead: "Cash in hand",
                        amount: this.totalPaidCash, type: "Credit",
                    });
                }
                if (this.totalPaidBank > 0) {
                    this.counterEntry.push({
                        accountID: 8, accountHead: "Cash at bank",
                        amount: this.totalPaidBank, type: "Credit",
                    });
                }
                if (this.totalPaidSupplierCreditClaim > 0) {
                    this.counterEntry.push({
                        accountID: 4, accountHead: "Accounts receivable",
                        amount: this.totalPaidSupplierCreditClaim, type: "Credit",
                    });
                }
                if (this.totalPaidSupplierCredit > 0) {
                    this.counterEntry.push({
                        accountID: 5, accountHead: "Accounts payable",
                        amount: this.totalPaidSupplierCredit, type: "Credit",
                    });
                }
            }
        }
    }

    calculateTotalAmount() {
        this.totalAmountAllRecords = 0;
        for (const item of this.lists as any[]) {
            if (item.type === 'SAA' || item.type === 'SAD') {
                // Use total_gross_amt — it is now 0 for free losses and stock found
                this.totalAmountAllRecords += Number(item.total_gross_amt);
            } else if (item.type === 'TSO' || item.type === 'TSI') {
                this.totalAmountAllRecords += Number(item.total_gross_amt);
            } else if (item.payment_method !== 'None') {
                this.totalAmountAllRecords += Number(item.total_bill);
            }
        }
    }

    calculateTotalBalance() {
        this.totalBalanceAllRecords = 0;
        for (const item of this.lists as any[]) {
            if ((item as any).type === 'TSI') {
                this.totalBalanceAllRecords += Number((item as any).branch_credit_payable ?? 0);
            } else if ((item as any).type === 'TSO') {
                this.totalBalanceAllRecords += Number((item as any).branch_credit_incoming ?? 0);
            } else {
                this.totalBalanceAllRecords += this.calculateBalance(
                    item.total_bill,
                    item.receipt_balance
                );
            }
        }
    }

    calculateBalance(totalBill, receiptBalance, data: any = null) {
        if (data && data.type === 'TSI') {
            return Number(data.branch_credit_payable ?? 0);
        }
        if (data && data.type === 'TSO') {
            return Number(data.branch_credit_incoming ?? 0);
        }
        let totalAmount = 0;
        receiptBalance.forEach((e) => {
            totalAmount = totalAmount + Number(e.trans_total_amount);
        });
        return Number(totalBill - totalAmount);
    }

    isFreeLoss(data): boolean {
        return data.type === 'SAD'
            && data.payment_method === 'None'
            && Number(data.total_gross_amt) === 0;
    }
 
    isStockFound(data): boolean {
        return data.type === 'SAA'
            && data.payment_method === 'None'
            && Number(data.total_gross_amt) === 0;
    }

    get canStockTransfer(): boolean {
        const perms = this.store.getters.gerUserPermissions;
        if (!perms) return false;
        try {
            const permArray = typeof perms === 'string' ? JSON.parse(perms) : perms;
            if (!Array.isArray(permArray)) return false;
            return permArray.some((p) =>
                typeof p === 'string' ? p === 'stock_transfer' : p?.name === 'stock_transfer'
            );
        } catch {
            return false;
        }
    }

    confirmTsoReceipt() {
        this.tsoConfirmDialog = false;

        const payments = this.tsoPreloadedPayments.map((p: any) => ({
            paymentTypeID: p.paymentTypeID,
            paymentType: p.paymentType,
            accountNo: '',
            transTotalAmount: Number(p.amount),
            terminalId: p.paymentType,
            authCode: '', hostResponse: '', transId: '',
            transStatus: '000',
            transType: this.item.type,
            transDate: '', transTime: '',
            transAmount: Number(p.amount),
            transRef: '', entryMode: '', giftCardRef: '', cardBalance: '',
            tendered: Number(p.amount), change: 0, roundOff: 0, bankID: 0,
            description: `Received ${p.paymentType} payment for stock transfer`,
        }));

        this.paymentList = payments;
        this.setAccountingEntries();

        this.receiptService
            .savePayment(this.item, this.paymentList, this.counterEntry)
            .then((res) => {
                if (res.alert == "info") {
                    this.loadList(this.goToFirstLink);
                    this.clearAll();
                }
                this.toast.handleResponse(res);
            });

        this.submitted = false;
    }

    /*
    stockLeft() {
        this.receiptService.stockLeft(this.item).then((res) => {
            if (res.alert == "info") {
                this.loadList(this.goToFirstLink);
                this.clearAll();
            }

            this.toast.handleResponse(res);
        });

        this.menuBar = false;
    }

    saveStock() {
        this.receiptService.saveStock(this.item).then((res) => {
            if (res.alert == "info") {
                this.loadList(this.goToFirstLink);
                this.clearAll();
            }

            this.toast.handleResponse(res);
        });

        this.menuBar = false;
    }
    voidReceipt() {
        this.receiptService.voidStock(this.item).then((res) => {
            if (res.alert == "info") {
                this.loadList(this.goToFirstLink);
                this.clearAll();
            }

            this.toast.handleResponse(res);
        });

        this.menuBar = false;
    } 
    */
}
